import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

const Tooltip = ({
  bgColor = '#333333',
  children,
  effect = 'float',
  hoverColor,
  maxWidth = 'none',
  position = 'top',
  text,
  textColor = '#fff',
}) => {
  return (
    <TooltipContainer hoverColor={hoverColor}>
      <span data-tip data-for={text}>
        {children}
      </span>
      <ReactTooltip
        id={text}
        place={position}
        effect={effect}
        textColor={textColor}
        backgroundColor={bgColor}
        arrowColor={bgColor}
        delayShow={100}
        delayHide={100}
        multiline={true}
      >
        <div
          style={{
            maxWidth: maxWidth,
            overflowWrap: 'break-word',
          }}
        >
          {text}
        </div>
      </ReactTooltip>
    </TooltipContainer>
  );
};

Tooltip.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  effect: PropTypes.oneOf(['float', 'solid']),
  hoverColor: PropTypes.string,
  maxWidth: PropTypes.string,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

export default Tooltip;

const TooltipContainer = styled.div`
  display: inline-block;
  font-weight: 500;
`;
